// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// GÜVENLİK — BUNU SİLME: Misafir (anon) canlı sohbet RLS'i, her isteğin
// x-visitor-id başlığını taşımasına dayanır. Bu başlık olmadan misafir kendi
// konuşmasını REST'ten OKUYAMAZ (chat_conversations/chat_messages politikaları).
// ChatWidget aynı 'chat_visitor_id' localStorage anahtarını kullanır → değerler eşleşir.
const getOrCreateVisitorId = (): string => {
  try {
    let v = localStorage.getItem("chat_visitor_id");
    if (!v) {
      v = crypto?.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random()}`;
      localStorage.setItem("chat_visitor_id", v);
    }
    return v;
  } catch {
    return "";
  }
};
const VISITOR_ID = typeof window !== "undefined" ? getOrCreateVisitorId() : "";

// ⛔ ANA İSTEMCİYE ASLA global header EKLEME! Edge fonksiyonlarının CORS izin listesi sabittir
// (authorization, x-client-info, apikey, content-type). Listede olmayan bir header eklenirse
// tarayıcı preflight'ta TÜM functions.invoke çağrılarını sessizce iptal eder — 12-14 Tem'de
// bildirimler dahil her invoke bu yüzden öldü (kanıtlı kök sebep). x-visitor-id yalnız aşağıdaki
// misafir-sohbet istemcisinde gönderilir (PostgREST CORS'u header'ları yansıtır, REST'te sorun yok).
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  },
});

// Misafir (anon) canlı sohbet İÇİN AYRI istemci: chat RLS'i x-visitor-id header'ına bakar.
// Sadece REST (chat_conversations/chat_messages) çağrılarında kullanılır; edge invoke'da KULLANMA.
export const supabaseChatGuest = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: { persistSession: false, autoRefreshToken: false },
  global: { headers: VISITOR_ID ? { "x-visitor-id": VISITOR_ID } : {} },
});